/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Options_TitleInputs */

const en_export_power_point_options_title = /** @type {(inputs: Export_Power_Point_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Options`)
};

const de_export_power_point_options_title = /** @type {(inputs: Export_Power_Point_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportoptionen`)
};

/**
* | output |
* | --- |
* | "Export Options" |
*
* @param {Export_Power_Point_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_options_title = /** @type {((inputs?: Export_Power_Point_Options_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Options_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_options_title(inputs)
	return de_export_power_point_options_title(inputs)
});